import { render, staticRenderFns } from "./NotificationView.vue?vue&type=template&id=c6c8a35c&scoped=true&"
import script from "./NotificationView.vue?vue&type=script&lang=js&"
export * from "./NotificationView.vue?vue&type=script&lang=js&"
import style0 from "./NotificationView.vue?vue&type=style&index=0&id=c6c8a35c&scoped=true&lang=css&"
import style1 from "./NotificationView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c8a35c",
  null
  
)

export default component.exports